const OrderTypeEnum = {
    FREEPHOTO: "FreePhoto",
    CREDIT_AND_PAYMENT: "Mixed",
    PAYMENT: "Payment",
    CREDIT: "Credit",
    ERROR: "Error"
}

export default OrderTypeEnum;